export default __webpack_public_path__ + "static/media/anthem-website-logos_goodup.391fe439.webp";